import type { RegistryEntry } from '../types';

// Hailuo 02 / 2.3 / 2.3 Fast：提示词优化 + 快速预处理
export const hailuoConfigs: Record<string, RegistryEntry> = {
    ...Object.fromEntries(
        ['hailuo-02', 'hailuo-2.3', 'hailuo-2.3-fast'].map(id => [id, {
            options: [
                { key: 'promptOptimizer', label: 'Prompt Optimizer', type: 'switch', default: true, group: 'advanced' },
                { key: 'fastPretreatment', label: 'Fast Pretreatment', type: 'switch', default: false, group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                promptOptimizer: typeof ui.promptOptimizer === 'boolean' ? ui.promptOptimizer : true,
                fastPretreatment: typeof ui.fastPretreatment === 'boolean' ? ui.fastPretreatment : false,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
    // WaveSpeed MiniMax H3 Open Weights
    'minimax-h3-open': {
        options: [
            { key: 'seed', label: 'Seed', type: 'number', min: -1, max: 2147483647, step: 1, group: 'advanced' },
        ],
        toProviderOptions: (ui) =>
            ({
                ...(typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? { seed: ui.seed } : {}),
            } as unknown as Record<string, Record<string, any>>),
    },
    // fal MiniMax H3 Max
    'minimax-h3-max': {
        options: [
            {
                key: 'prompt_expansion_mode',
                label: 'Prompt Expansion',
                type: 'select',
                options: [
                    { label: 'Balanced', value: 'balanced' },
                    { label: 'Quality', value: 'quality' },
                ],
                default: 'balanced',
                group: 'advanced',
            },
            { key: 'seed', label: 'Seed', type: 'number', min: -1, max: 2147483647, step: 1, group: 'advanced' },
        ],
        toProviderOptions: (ui) =>
            ({
                prompt_expansion_mode: ui.prompt_expansion_mode === 'quality' ? 'quality' : 'balanced',
                ...(typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? { seed: ui.seed } : {}),
            } as unknown as Record<string, Record<string, any>>),
    },
};